import { jsx as t } from "react/jsx-runtime";
import { c as d } from "./index-BNmRGtA6.js";
import { c } from "./clsx-OuTLNxxd.js";
import './Badge.css';const m = "_badge_8vkru_1", u = "_primary_8vkru_11", z = "_secondary_8vkru_17", v = "_error_8vkru_23", y = "_isRound_8vkru_36", s = {
  badge: m,
  primary: u,
  secondary: z,
  error: v,
  "size-xs": "_size-xs_8vkru_29",
  isRound: y,
  "size-s": "_size-s_8vkru_41",
  "size-m": "_size-m_8vkru_53",
  "size-l": "_size-l_8vkru_67"
}, p = d(s.badge, {
  variants: {
    isRound: {
      true: s.isRound
    },
    size: {
      xs: s["size-xs"],
      s: s["size-s"],
      m: s["size-m"],
      l: s["size-l"]
    },
    variant: {
      primary: s.primary,
      secondary: s.secondary,
      error: s.error
    }
  },
  defaultVariants: {
    isRound: !1,
    size: "m",
    variant: "primary"
  }
}), g = ({
  children: r,
  className: a,
  isRound: e,
  size: i,
  style: o,
  variant: _,
  ...n
}) => /* @__PURE__ */ t(
  "span",
  {
    className: c(p({ isRound: e, size: i, variant: _ }), a),
    "data-cxy-name": "badge",
    style: o,
    ...n,
    children: r
  }
);
export {
  g as B
};
